import { FC } from 'react'
import { RenderIf } from 'components/RenderIf'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { IProduct } from 'featureSliced/shared/store/reducers/CategoriesReducer/types'
import { convertToPrice } from 'featureSliced/shared/utils/convertToPrice'
import { useGetProductPrice } from 'featureSliced/shared/hooks/useGetProductPrice/indexT'

import {
  MinMaxWarning,
  ProductTitlePrice,
  // ProductTotalPrice,
  TitleAndPriceContainer,
} from './styled'
import { useGetTranslatedNames } from '../../../useGetTranslatedNames'
import { ProductTemplateIdType } from 'featureSliced/shared/store/reducers/QRMenuBucketReducer/types'

type TitleAndPriceProps = {
  product: IProduct
  productTemplateId: ProductTemplateIdType
  currentAmount: number
}

export const TitleAndPrice: FC<TitleAndPriceProps> = ({
  product,
  productTemplateId,
  currentAmount = 1,
}) => {
  // Store
  const Currency = useMySelector((state) => state.app.companyData.Currency)
  const { getProductName } = useGetTranslatedNames()
  const { getProductPrice } = useGetProductPrice()
  const { finalPrice, priceOG, discountValue, isOffer } = getProductPrice(
    product,
    productTemplateId
  )

  return (
    <TitleAndPriceContainer>
      {/* <p>{product.title}</p> */}
      <p>{getProductName(product)}</p>
      <RenderIf condition={product.unitSellCode === 1 && Boolean(finalPrice)}>
        <ProductTitlePrice isDiscounted={Boolean(discountValue) || isOffer}>
          <RenderIf condition={isOffer && Boolean(priceOG)}>
            <s>{convertToPrice(priceOG * currentAmount)}</s>
            <>&thinsp;</>
          </RenderIf>
          {convertToPrice(finalPrice * currentAmount)}&thinsp;
          {Currency || ''}
        </ProductTitlePrice>
      </RenderIf>
    </TitleAndPriceContainer>
  )
}
